<template>
  <div class="payFlow">
    <table-search label-width="65px" @search="fetchList(1)" @reset="handleReset">
      <template v-slot:basic>
        <el-form-item label="市场名称">
          <el-select v-model="query.marketCode" clearable placeholder="请选择">
            <el-option v-for="(item, index) in $key.common.market" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付单号">
          <el-input v-model="query.payCode" placeholder="请输入支付单号"/>
        </el-form-item>
        <el-form-item label="业务单号">
          <el-input v-model="query.bizId" placeholder="请输入业务单号"/>
        </el-form-item>
        <el-form-item label="交易类型">
          <el-select v-model="query.flowTypes" clearable placeholder="请选择交易类型">
            <el-option v-for="item in $key.myAccount.flowType" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.flowStatus" clearable placeholder="请选择状态">
            <el-option v-for="item in $key.myAccount.flowStatus" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付日期" class="date-range">
          <el-date-picker v-model="query.date" type="daterange" clearable start-placeholder="开始日期" end-placeholder="结束日期"/>
        </el-form-item>
      </template>
    </table-search>
    <inquery-result @export="toDownload"></inquery-result>
    <el-table :data="tableData">
      <el-table-column label="支付单号" prop="payCode" align="center"/>
      <el-table-column label="业务单号" prop="bizId" align="center"/>
      <el-table-column label="交易类型" prop="flowType" align="center">
        <template slot-scope="scope">
          {{ scope.row.flowType | keyFilter('myAccount', 'flowType') }}
        </template>
      </el-table-column>
      <el-table-column label="金额" prop="money" align="right">
        <template slot-scope="scope">
          {{ scope.row.money | thousandMark }}
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="flowStatus" align="center">
        <template slot-scope="scope">
          {{ scope.row.flowStatus | keyFilter('myAccount', 'flowStatus') }}
        </template>
      </el-table-column>
      <el-table-column label="支付时间" prop="payTime" align="center"/>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="detail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout='total, prev, pager, next' :current-page.sync="currentPage" :total='total' @current-change="changePage" background></el-pagination>
    <detail v-if="operate === 'detail'" :row='row' @close='close'/>
  </div>
</template>

<script>
import api from '@/api'
import detail from './detail.vue'
function Query () {
  return {
    marketCode: '',
    payCode: '',
    id: '',
    date: [],
    flowTypes: '',
    flowStatus: '',
  }
}
export default {
  name: 'payFlow', // 保证金账户-支付流水
  components: {
    detail
  },
  data () {
    return {
      query: new Query(),
      tableData: [], // 表格数据
      currentPage: 1,
      total: 0,
      pageSize: 10,
      operate: 'list',
      row: {},
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (pageNumber, pageSize) {
      this.currentPage = pageNumber || this.currentPage
      this.pageSize = pageSize || this.pageSize
      const param = {
        ...this.query,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        startDate: this.query.date && this.query.date.length === 2 ? this.$dayjs(this.query.date[0]).format('YYYYMMDD') : '',
        endDate: this.query.date && this.query.date.length === 2 ? this.$dayjs(this.query.date[1]).format('YYYYMMDD') : ''
      }
      api.myAccount.flowList(param).then(res => {
        this.tableData = res.data.rows
        this.total = res.data.totalElements
      })
    },
    toDownload () {

    },
    // 详情
    detail (row) {
      this.operate = 'detail'
      this.row = row
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
    close () {
      this.operate = 'list'
      this.row = {}
      this.fetchList(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style lang='scss' scoped>
.payFlow .pagination {
  float: right;
  margin-top: 20px;
}
</style>
